import { configureStore } from '@reduxjs/toolkit'
import authenticationReducer from './components/_redux/authentication/authenticationSlice'

export const store = configureStore({
  reducer: {
    authentication: authenticationReducer
  }
})